module.exports = __webpack_public_path__ + "static/img/img_title_es.580115a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newYear-2023/img_title_es.png
// module id = tHZ/
// module chunks = 1